import request from "@/router/axios";

export const getWeeklyAnalysis = (params) => {
  return request({
    url: "/api/produce/road-outbound/stats/weekly-analysis",
    method: "post",
    data: params,
  });
};

export const getWeeklyDetailPage = (params) => {
  return request({
    url: "/api/produce/road-outbound/sale-weight/page",
    method: "post",
    data: params,
  });
};

export const getCustomerOptions = (deptName) => {
  const params = deptName ? { deptName } : {};
  return request({
    url: "/api/produce/blade-dept/select/distinct/select",
    method: "get",
    params,
  });
};

export const getVarOptions = (varName) => {
  const params = {
    page: 1,
    size: 20,
  };
  if (varName) {
    params.varName = varName;
  }
  return request({
    url: "/api/produce/vardict/select/distinct/pycode",
    method: "get",
    params,
  });
};
